import React, {useCallback, useContext} from 'react';
import get from 'lodash/get';

import Element from '~/src/components/element/Element';

import {classNameByType, classNames} from '~/src/utilities/helpers/css';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {SiteArea} from '~/src/utilities/constants/navigation';
import {ElementTypes} from '~/src/utilities/constants/types';

import css from './Article.module.scss';

const renderElement = (element, id, meta, index) => {
    const className = classNameByType(css, element.type);

    if (element.type === 'image' && element.image) {
        element.image.maxAspectRatio = parseFloat(css.slideshow);
    }

    return (
        <div key={index} className={className}>
            <Element {...element} meta={meta} position={index + 1} id={id} />
        </div>
    );
};

const splitElements = (elements) => {
    const firstBodyElement = 1 + elements.findIndex((element) => element.type === ElementTypes.AUTHORS);
    return {
        header: elements.slice(0, firstBodyElement),
        body: elements.slice(firstBodyElement)
    };
};

const Article = (props) => {
    const {article, id, meta} = props;
    const settings = useContext(SettingsContext);
    const siteArea = get(settings, 'siteArea', SiteArea.NEWS);
    const className = classNames(css, 'article', siteArea);
    const elements = splitElements(article.elements);

    const mapHeader = useCallback((element, index) => renderElement(element, id, meta, index), [id, meta]);
    const mapBody = useCallback((element, index) => renderElement(element, id, meta, elements.header.length + index), [id, meta]);

    return (
        <article className={className}>
            <header className={css.header}>{elements.header.map(mapHeader)}</header>
            <section className={css.body}>{elements.body.map(mapBody)}</section>
        </article>
    );
};

export default Article;
